(function () {
  const settings = window.FreeGiftSettings;
  if (!settings || !settings.enabled || !settings.variantId || !settings.threshold) return;

  const VARIANT_ID = Number(settings.variantId);
  const THRESHOLD  = Number(settings.threshold);
  const ROOT_URL   = window.Shopify.routes.root;

  /* ---- formatare suma ---- */
  function formatMoney(cents) {
    const fmt = settings.moneyFormat || '{{amount}}';
    const amount    = (cents / 100).toFixed(2);
    const amountInt = Math.round(cents / 100).toString();
    return fmt
      .replace('{{amount}}',                             amount)
      .replace('{{amount_no_decimals}}',                 amountInt)
      .replace('{{amount_with_comma_separator}}',        amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', amountInt);
  }

  /* ---- confetti ---- */
  function fireConfetti(canvas) {
    if (!canvas) return;
    const dpr  = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width  = rect.width  * dpr;
    canvas.height = rect.height * dpr;
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    const W = rect.width, H = rect.height;
    const CX = W / 2, CY = H / 2;

    const COLORS = [
      'hsl(43,96%,56%)',  'hsl(43,80%,70%)',
      'hsl(350,80%,65%)', 'hsl(35,90%,60%)',
      'hsl(150,50%,55%)', 'hsl(145,60%,45%)',
      'hsl(50,90%,70%)',
    ];

    const particles = Array.from({ length: 45 }, () => {
      const angle = Math.random() * Math.PI * 2;
      const speed = 2 + Math.random() * 4;
      return {
        x: CX, y: CY,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 2 - Math.random() * 2,
        size: 3 + Math.random() * 5,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        rotation: Math.random() * 360,
        rotSpeed: (Math.random() - 0.5) * 12,
        opacity: 1,
        shape: ['circle', 'rect', 'star'][Math.floor(Math.random() * 3)],
      };
    });

    function draw() {
      ctx.clearRect(0, 0, W, H);
      let alive = false;
      for (const p of particles) {
        if (p.opacity <= 0) continue;
        alive = true;
        p.x  += p.vx;
        p.y  += p.vy;
        p.vy += 0.12;
        p.vx *= 0.99;
        p.rotation += p.rotSpeed;
        p.opacity  -= 0.012;

        ctx.save();
        ctx.globalAlpha = Math.max(0, p.opacity);
        ctx.fillStyle   = p.color;
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);

        if (p.shape === 'circle') {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
          ctx.fill();
        } else if (p.shape === 'rect') {
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        } else {
          ctx.beginPath();
          for (let i = 0; i < 8; i++) {
            const a = (i / 8) * Math.PI * 2;
            const r = i % 2 === 0 ? p.size / 2 : p.size / 4;
            i === 0 ? ctx.moveTo(Math.cos(a) * r, Math.sin(a) * r)
                    : ctx.lineTo(Math.cos(a) * r, Math.sin(a) * r);
          }
          ctx.closePath();
          ctx.fill();
        }
        ctx.restore();
      }
      if (alive) requestAnimationFrame(draw);
    }
    draw();
  }

  /* ---- init widget ---- */
  function initWidget(widget) {
    const progressEl    = widget.querySelector('.gift-widget__progress');
    const successEl     = widget.querySelector('.gift-widget__success');
    const barEl         = widget.querySelector('.gift-widget__bar');
    const percentEl     = widget.querySelector('.gift-widget__percent');
    const textEl        = widget.querySelector('.gift-widget__text');
    const labelEl       = widget.querySelector('.gift-widget__label');
    const successTextEl = widget.querySelector('.gift-widget__success-text');
    const canvasEl      = widget.querySelector('.gift-widget__confetti');
    const successInner  = widget.querySelector('.gift-widget__success-inner');

    const tplProgress  = widget.dataset.progressText  || 'Mai adaugă {amount} pentru cadoul gratuit';
    const tplLabel     = widget.dataset.label         || 'CADOU GRATUIT';
    const tplUnlocked  = widget.dataset.unlockedText  || 'Cadoul tău va fi adăugat automat';
    const tplInCart    = widget.dataset.inCartText    || 'Cadoul tău gratuit e în coș ✓';

    let lastState      = null;
    let confettiFired  = false;

    function update(cart) {
      const giftItem   = cart.items ? cart.items.find(i => i.variant_id === VARIANT_ID) : null;
      const giftPrice  = giftItem ? giftItem.line_price : 0;
      const subtotal   = (cart.total_price || 0) - giftPrice;
      const progress   = Math.min(subtotal / THRESHOLD, 1);
      const percent    = Math.round(progress * 100);
      const remaining  = Math.max(THRESHOLD - subtotal, 0);
      const inCart     = !!giftItem;
      const unlocked   = subtotal >= THRESHOLD;

      if (unlocked || inCart) {
        progressEl.hidden = true;
        successEl.hidden  = false;

        if (inCart) {
          // starea "in cos" — emoji + text confirmare
          labelEl.hidden = true;
          let emojiEl = successInner.querySelector('.gift-widget__emoji');
          if (!emojiEl) {
            emojiEl = document.createElement('span');
            emojiEl.className = 'gift-widget__emoji';
            emojiEl.textContent = '🎁';
            successInner.prepend(emojiEl);
          }
          emojiEl.hidden = false;
          successTextEl.textContent = tplInCart;
        } else {
          // starea "deblocat" — label + text asteptare
          labelEl.hidden = false;
          labelEl.textContent = tplLabel;
          const emojiEl = successInner.querySelector('.gift-widget__emoji');
          if (emojiEl) emojiEl.hidden = true;
          successTextEl.textContent = tplUnlocked;
        }

        if (lastState !== 'success') {
          successEl.classList.remove('gift-widget__success--reveal');
          void successEl.offsetWidth; // reflow
          successEl.classList.add('gift-widget__success--reveal');
          widget.classList.remove('gift-widget--jiggle');
          void widget.offsetWidth;
          widget.classList.add('gift-widget--jiggle');
          setTimeout(() => widget.classList.remove('gift-widget--jiggle'), 600);
          if (!confettiFired) {
            confettiFired = true;
            fireConfetti(canvasEl);
          }
        }
        lastState = 'success';
      } else {
        confettiFired    = false;
        progressEl.hidden = false;
        successEl.hidden  = true;

        barEl.style.width = percent + '%';
        percentEl.textContent = percent + '%';

        const formattedRemaining = formatMoney(remaining);
        textEl.innerHTML = tplProgress.replace(
          '{amount}',
          `<strong class="gift-widget__amount">${formattedRemaining}</strong>`
        );

        lastState = 'progress';
      }
    }

    function handleEvent(detail) {
      if (detail && Array.isArray(detail.items)) {
        update(detail);
      } else {
        fetch(ROOT_URL + 'cart.json').then(r => r.json()).then(update);
      }
    }

    // fetch initial
    fetch(ROOT_URL + 'cart.json').then(r => r.json()).then(update);

    document.addEventListener('theme:cart:add',    e => handleEvent(e.detail));
    document.addEventListener('theme:cart:update', e => handleEvent(e.detail));
  }

  document.querySelectorAll('[data-gift-widget]').forEach(initWidget);
})();
